module.exports = __webpack_public_path__ + "img/placeholder.b2bd38f2.svg";